export default __webpack_public_path__ + "static/media/dark.bd17c7b5.svg";